import { ArrowRight } from "lucide-react";
import { DTORBIT_URL } from "@/constants";
import { Reveal } from "./Reveal";

export default function CtaBanner() {
    return (
        <section
            data-testid="cta-banner-section"
            className="relative py-16 md:py-24"
        >
            <div className="max-w-7xl mx-auto px-4 sm:px-6">
                <Reveal>
                    <div className="relative overflow-hidden rounded-3xl bg-gradient-to-br from-[#1E56FF] via-[#2E6BFF] to-[#1FA8E0] px-6 py-14 sm:px-12 md:py-20 text-center">
                        <div className="pointer-events-none absolute -top-24 left-1/4 w-[380px] h-[380px] rounded-full bg-white/20 blur-[110px]" />
                        <div className="pointer-events-none absolute -bottom-32 right-0 w-[320px] h-[320px] rounded-full bg-[#0A1F9E]/20 blur-[100px]" />
                        <svg
                            className="pointer-events-none absolute inset-0 w-full h-full opacity-[0.12]"
                            aria-hidden="true"
                        >
                            <defs>
                                <pattern
                                    id="cta-rings"
                                    width="120"
                                    height="120"
                                    patternUnits="userSpaceOnUse"
                                >
                                    <circle
                                        cx="60"
                                        cy="60"
                                        r="46"
                                        fill="none"
                                        stroke="#FFFFFF"
                                        strokeWidth="1"
                                    />
                                </pattern>
                            </defs>
                            <rect width="100%" height="100%" fill="url(#cta-rings)" />
                        </svg>

                        <div className="relative">
                            <h2 className="font-display text-3xl sm:text-4xl md:text-5xl font-extrabold tracking-tight text-white">
                                Start Your USDT to INR Exchange
                            </h2>
                            <p className="mt-4 text-sm md:text-lg text-[#E4EEFF] max-w-xl mx-auto">
                                Start your USDT to INR exchange with DtOrbit today.
                            </p>
                            <a
                                href={DTORBIT_URL}
                                data-testid="cta-banner-start-exchange-button"
                                className="btn-white mt-9"
                                aria-label="Start USDT to INR Exchange on DtOrbit"
                            >
                                Start USDT to INR Exchange
                                <ArrowRight className="w-5 h-5" />
                            </a>
                        </div>
                    </div>
                </Reveal>
            </div>
        </section>
    );
}
